import { CSSProperties, useState } from "react";
import OliverImage from "../OliverImage";
import "./style.scss";
import OliverText from "@builder/components/general/OliverText";
import { useTranslation } from "react-i18next";

interface MiniEditableiCollapseProps {
    title: string;
    children: React.ReactNode;
    open?: boolean;
    onDelete?: () => void;
    onCopy?: () => void;
    styles?: CSSProperties;
    noTranslate?: boolean;
}

const MiniEditableiCollapse = ({ title, children, open = false, styles, noTranslate, onCopy, onDelete }: MiniEditableiCollapseProps) => {
    const { t } = useTranslation();
    const [isCollapsed, setIsCollapsed] = useState<boolean>(!open);

    const handleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };

    return (
        <div className="mini-editable-collapse-wrapper">
            <div className="mini-title-row" onClick={handleCollapse}>
                <div className="side">
                    <OliverText text={noTranslate ? title : t("miniEditableCollapse." + title)} size="xs" />
                </div>
                <div className="side">
                    {onCopy && (
                        <div
                            onClick={e => {
                                e.stopPropagation();
                                onCopy();
                            }}
                        >
                            <OliverImage src="/copy-icon-blue.svg" />
                        </div>
                    )}
                    {onDelete && (
                        <div
                            className="delete"
                            onClick={e => {
                                e.stopPropagation();
                                onDelete();
                            }}
                        >
                            <OliverImage src="/trash.svg" />
                        </div>
                    )}
                </div>
            </div>
            {isCollapsed ? (
                ""
            ) : (
                <div className="mini-editable-collapse-content" style={styles}>
                    {children}
                </div>
            )}
        </div>
    );
};

export default MiniEditableiCollapse;
